import { INFLIGHT_DEPOSIT_TTL_MS } from "@configs/deposit-flow";
import { STORAGE_KEY } from "@constants";
import { readJSONFromStorage, removeFromStorage, writeJSONToStorage } from "@utils/storage";

export interface InflightDeposit {
  orderRef: string;
  startedAt: number; // epoch ms
}

function read(): InflightDeposit[] {
  const list = readJSONFromStorage<InflightDeposit[]>(STORAGE_KEY.INFLIGHT_DEPOSITS, []);
  return Array.isArray(list) ? list : [];
}

export function addInflightDeposit(orderRef: string, startedAt: number): void {
  if (!orderRef) return;
  const list = read().filter((d) => d.orderRef !== orderRef);
  list.push({ orderRef, startedAt });
  writeJSONToStorage(STORAGE_KEY.INFLIGHT_DEPOSITS, list);
}

export function removeInflightDeposit(orderRef: string): void {
  if (!orderRef) return;
  const list = read();
  const next = list.filter((d) => d.orderRef !== orderRef);
  if (next.length !== list.length) writeJSONToStorage(STORAGE_KEY.INFLIGHT_DEPOSITS, next);
}

/** Returns non-expired in-flight deposits and prunes expired entries from storage. */
export function getActiveInflightDeposits(now: number, ttlMs: number = INFLIGHT_DEPOSIT_TTL_MS): InflightDeposit[] {
  const list = read();
  const active = list.filter((d) => now - d.startedAt <= ttlMs);
  if (active.length !== list.length) writeJSONToStorage(STORAGE_KEY.INFLIGHT_DEPOSITS, active);
  return active;
}

/** Clears the durable in-flight ledger. Call on logout / account switch. */
export function clearInflightDeposits(): void {
  removeFromStorage(STORAGE_KEY.INFLIGHT_DEPOSITS);
}
